import React from "react";
import EvalResponses from "./EvalResponses";

const RATING_OPTIONS = [
  'Strongly Agree',
  'Agree',
  'Disagree',
  'Neutral',
];

export default function EvalEventPartnerResponses(props) {
  return (
    <EvalResponses
      {...props}
      table="evaluationEventPartner"
      ratingOptions={RATING_OPTIONS}
    />
  );
}
